import React, { useEffect, useRef, useState } from "react";
import BasePopup from "../Popup";
import iconClosePopup from "../../../../../assets/images/Mini-Game/icon-close-popup.svg";
import styled from "styled-components";
import congratsRibbon from "../../../../../assets/images/Mini-Game/congrats-ribbon.png";
import congratsRibbonTBN from "../../../../../assets/images/Event-2026/congrats-ribbonTBN.png";
import bgBtn from "../../../../../assets/images/Mini-Game/bg-btn-piece-popup.png";
import ButtonAction from "./components/ButtonAction";
import { useDispatch } from "@pages/Events/MiniGame/store";
import { setDataSpinLeft, setOpenPopupPiece } from "../../../../../Redux/futures/mini-game/action";
import {
  ID_GIFT_PLAY_LOTO_MINIGAME,
  ID_TAB_MINI_GAME,
  TYPE_DETAIL_PUZZLE_PIECE,
} from "../../../../../helper/const";
import iconBidFree from "../../../../../assets/images/Mini-Game/icon-bid-free.png";
import iconCoin from "../../../../../assets/images/Mini-Game/icon-coin.png";
import iconGoodluck from "../../../../../assets/images/Mini-Game/icon-good-luck.png";
import oopsTitle from "../../../../../assets/images/Mini-Game/oops.png";
import oopsTitleTBN from "../../../../../assets/images/Event-2026/oopsTBN.png";
import bgNoCoins from "../../../../../assets/images/Mini-Game/bg-no-coins.png";
import iconNoCoins from "../../../../../assets/images/Mini-Game/icon-no-coins.png";
import bgNoCoinsHead from "../../../../../assets/images/Mini-Game/bg-no-coin-head.png";
import PopupEarnMore from "./PopupEarnMore";
import { useNavigate } from "@hooks/useNavigate";
import PATH from "../../../../../config/PATH";
import bgPuzzlePiece from "../../../../../assets/images/Mini-Game/bg-puzzle-piece.png";
import { Trans, useTranslation } from "react-i18next";
import { getTurnRemain } from "../../../../../Redux/futures/account/actions";
import { mediaQueryPoint, useMediaQuery } from "../../../../../utils/hooks";
import { Button } from "antd";
import pieceDemo from "../../../../../assets/images/Mini-Game/piece-demo.png";
import bgCongrats from "../../../../../assets/images/Mini-Game/bg-congrats.png";
import PopupChangeCoin from "../PopupChangeCoin/PopupChangeCoin";
import imgTitlePiece from "../../../../../assets/images/Event-2026/puzze-piece.png";

export default function PopupCongPiece({
  isOpen = false,
  className,
  type,
  data,
  onCancel,
  setOpenPopupChangeCoin,
  setTurn,
  turn,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  const [opacityItem, setOpacityItem] = useState(
    +type === ID_GIFT_PLAY_LOTO_MINIGAME.coin_super ||
      +type === ID_GIFT_PLAY_LOTO_MINIGAME.puzzle_piece
      ? false
      : true,
  );

  const handleClickSeeAll = () => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.prizeCollection}`);
    if (onCancel) onCancel();
  };

  const handleClickEarnMore = () => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.collectPiece}`);
    if (onCancel) onCancel();
  };

  const handleToBid = () => {
    navigate(`${PATH.BID}/running`);
    if (onCancel) onCancel();
  };

  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);
  const isMobileSmall = useMediaQuery(`(max-width: ${mediaQueryPoint.sm}px)`);

  // quay super
  const elementRef = useRef(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (
      elementRef.current &&
      (type === ID_GIFT_PLAY_LOTO_MINIGAME.coin_super ||
        type === ID_GIFT_PLAY_LOTO_MINIGAME.puzzle_piece)
    ) {
      let timeoutsetHeight = null;
      const handleGetTimeout = () => {
        timeoutsetHeight = setTimeout(() => {
          let elementHeight = elementRef.current.offsetHeight;

          // if(+elementHeight > 1000) {
          //   if(data?.name && data?.name.length < 21) {
          //     elementHeight = 440
          //   }
          //   else if( data?.name && data?.name.length < 40) {
          //     elementHeight = 508
          //   }
          // }
          // console.log("elementHeight", elementHeight);
          if (+elementHeight > 350 && count <= 5) {
            setCount((prev) => prev + 1);
            handleGetTimeout();
          }
          if (+elementHeight > 1000) {
            if (data?.name && data?.name.length < 21) {
              elementHeight = 440;
            } else if (data?.name && data?.name.length < 40) {
              elementHeight = 508;
            }
          }
          const heightActive = +elementHeight + 160;
          if (count === 5) {
            setOpacityItem(true);
          }
          if (count < 5) {
            setOpacityItem(false);
          }
          // console.log("heightActive", heightActive);

          setHeight(heightActive);
        }, [1000]);
      };
      handleGetTimeout();
      return () => clearTimeout(timeoutsetHeight);
    }
  }, [type, isOpen, isMobile, count]);

  if (!type) {
    return <></>;
  }
  // console.log(data);

  return (
    // <div style={{opacity: `${opacityItem ? 1 : 0}`}}>
    <BasePopup
      BasePopup
      open={isOpen}
      className={className}
      onCancel={onCancel}
      getContainer
      centered={false}
      showClose={true}
      closable={true}
    // width={isMobileSmall ? "90%" : undefined}
    >
      <div
        src={iconClosePopup}
        alt=""
        className="rule-mini-close button-hover__minigame"
        onClick={onCancel}
      />
      {type === ID_GIFT_PLAY_LOTO_MINIGAME.puzzle_piece ? (
        <Container height={height}>
          <Ribbon />
          <Content>
            <div ref={elementRef} className="content-inner">
              <div className="content-header">
                <Trans
                  i18nKey="You_have_received_a_X"
                  values={{
                    prizeName: data?.name || "",
                    pieceName: data?.obj_puzzle_piece?.name || "",
                  }}
                  components={{
                    highlight: <span className="content-header__highlight" />,
                  }}
                />
              </div>
              <div className="content-icon">
                <img src={data?.obj_puzzle_piece?.image} style={{ maxHeight: "160px" }} alt="" />
              </div>
              <div className="content-name">
                <span className="content-name__piece-name">
                  {t('piece')} {data?.obj_puzzle_piece?.name}
                </span>
                <span className="content-name-special">{data?.name || ""}</span>
              </div>
            </div>
          </Content>
          <Footer
            buttonTitle={t('mini_game.piece_collection.earn_more_piece')}
            subTitle={t('complete_a_puzzle_to_take_that_prize')}
            onButtonClick={onCancel}
          />
        </Container>
      ) : type === ID_GIFT_PLAY_LOTO_MINIGAME.coin_super ? (
        <Container height={height}>
          <Ribbon />
          <Content>
            <div className="content-inner" ref={elementRef}>
              <div className="content-header">
                <Trans
                  i18nKey="You_have_received_a_X_from_a_Super_coin"
                  values={{
                    prizeName: data?.name || "",
                    pieceName: data?.obj_puzzle_piece?.name || "",
                  }}
                  components={{
                    highlight: <span className="content-header__highlight" />,
                  }}
                />
              </div>
              <div className="content-icon">
                <img style={{ maxHeight: "160px" }} src={data?.obj_puzzle_piece?.image} alt="" />
              </div>
              <div className="content-name">
                <span className="content-name__piece-name">
                  {t('piece')} {data?.obj_puzzle_piece?.name || ""}
                </span>
                <span className="content-name__prize-name">{data?.name || ""}</span>
              </div>
            </div>
          </Content>
          <Footer
            buttonTitle={t('earn_more_super_coins')}
            subTitle={t('super_coin_could_be_collected_by_CHANCE10_Weekly_and_Monthy_package')}
            onButtonClick={handleClickEarnMore}
            onSecondButtonClick={onCancel}
            secondButtonTitle={t('mini_game.piece_collection.earn_more_piece')}
          />
        </Container>
      ) : type === ID_GIFT_PLAY_LOTO_MINIGAME.bid_free ? (
        <Container>
          <Ribbon />
          <Content>
            <div className="content-inner">
              <div className="content-header" style={{ fontWeight: 500 }}>
                {t('you_have_received')}{" "}
              </div>
              <div className="content-name content-name-special">
                {data?.value} {"Free Bids".replace("s", +data?.value === 1 ? "" : "s")}
              </div>
              <div className="content-icon">
                <img src={iconBidFree} alt="" />
              </div>
              <div className="content-name" style={{ maxWidth: 290 }}>
                <span className="content-name__piece-name">
                  {t("place_your_bids_now_to_win", {
                    prizeName: data?.name,
                  })}
                </span>
              </div>
            </div>
          </Content>

          <Footer
            buttonTitle={t('bid_now')}
            subTitle={t('complete_a_puzzle_to_take_that_prize')}
            onButtonClick={() => {
              onCancel && onCancel();
              navigate(`/bid`);
            }}
          />
        </Container>
      ) : type === ID_GIFT_PLAY_LOTO_MINIGAME.add_spin ? (
        <Container>
          <Ribbon />
          <Content>
            <div className="content-inner">
              <div className="content-group">
                <div className="content-header">{t('you_have_received')}</div>
                <div className="content-name-special">
                  {+data?.award?.value > 1
                    ? `${data?.award?.value} ${t('Coins')}`
                    : `${data?.award?.value} ${t('coin')}`}
                </div>
                <div className="content-header">{t("from_world_cup_2026")}</div>
              </div>

              <div className="content-icon">
                <img src={iconCoin} alt="" />
              </div>
            </div>
          </Content>
          <Footer buttonTitle={t('mini_game.piece_collection.earn_more_piece')} subTitle={null} onButtonClick={onCancel} />
        </Container>
      ) : type === ID_GIFT_PLAY_LOTO_MINIGAME.good_luck ? (
        <Container className="popup-good-luck">
          <Ribbon isFail={true} />
          <Content>
            <div className="content-inner">
              <div className="icon">
                <img src={iconGoodluck} alt="" />
              </div>

              <div className="content-header">
                {t('you_found_a_good_luck')}
                <br />
                {t('try_again_for_other_chances_at_something_magical')}
              </div>
            </div>
          </Content>
        </Container>
      ) : type === ID_GIFT_PLAY_LOTO_MINIGAME.no_coins ? (
        <>
          <Container className="popup-good-luck">
            <Ribbon isFail={true} className="no-coins" />
            <Content>
              <div className="content-inner">
                <div className="content-header">{t('you_have_no_coins_left_to_spin_the_reel')}</div>
                <div className="content-icon">
                  <img src={iconNoCoins} alt="" />
                </div>
                <div className="content-name">
                  <span className="content-name__prize-name" style={{ fontSize: 28 }}>
                    {t('lets_earn_more_coins_now')}
                  </span>
                </div>
                <PopupEarnMore
                  isPopupNoCoins
                  onCancel={onCancel}
                  isPopupToRell
                  setOpenPopupChangeCoin={setOpenPopupChangeCoin}
                  setTurn={setTurn}
                  turn={turn}
                />
              </div>
            </Content>
          </Container>
        </>
      ) : type === TYPE_DETAIL_PUZZLE_PIECE ? (
        <Container>
          <div className="puzzle-piece-minigame popup-free-bid popup-puzzle-piece">
            <div className="main-content-mini-piece">
              <img className="title_img" src={imgTitlePiece} alt="" />
              <div className="icon">
                <img src={data.image_light} alt="" />
              </div>
              <div className="header">{t("mini_game.pop_up_puzzle_piece.you_have")}</div>
              <div className="name" style={{ lineHeight: "32px" }}>
                {data.num || 0} {t('prizes')} {data.awardName} - {t('piece')} ({data.name || ""})
              </div>
              <div style={{ marginTop: "25px" }} className="footer-popup-mini-cong">
                {t('mini_game.pop_up_puzzle_piece.complete')}
              </div>
              <div style={{ marginTop: "25px" }}>
                <div className="container-btn">
                  <ButtonAction
                    srcBg={false}
                    content={t("earn_more_pieces")}
                    handleClick={() => {
                      if (onCancel) {
                        onCancel();
                      }
                      navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Container>
      ) : null}
    </BasePopup>
  );
}

const Ribbon = ({ isFail = false, className = "" }) => {
  const { i18n } = useTranslation()
  return (
    <RibbonContainer className={className}>
      <img src={isFail ? i18n.language === 'en' ? oopsTitle : oopsTitleTBN : i18n.language === 'en' ? congratsRibbon : congratsRibbonTBN} alt="Ribbon" className="congrats-ribbon" />
    </RibbonContainer>
  );
};

const Content = ({ children }) => {
  return <ContentContainer>{children}</ContentContainer>;
};

const Footer = ({ buttonTitle = "", subTitle = "", onButtonClick, onSecondButtonClick, secondButtonTitle }) => {
  return (
    <FooterContainer>
      <div className="footer-buttons">
        {secondButtonTitle && (
          <button
            className="footer-button footer-button-secondary"
            onClick={onSecondButtonClick}
          >
            {secondButtonTitle}
          </button>
        )}
        {buttonTitle &&
          <button block className="footer-button" onClick={onButtonClick}>
            {buttonTitle}
          </button>
        }
      </div>
      {subTitle && <span className="footer-sub-title">{subTitle}</span>}
    </FooterContainer>
  );
};

const RibbonContainer = styled.div`
  padding-top: 64px;
  position: relative;
  padding-bottom: 6px;

  &.no-coins {
    padding-top: 24px;
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  padding: 0 12px;
  margin: 15px 0;

  .content-inner {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .content-header {
    font-size: 20px;
    color: white;
    text-align: center;
    .content-header__highlight {
      font-weight: bold;
    }
  }

  .content-icon {
    text-align: center;
  }

  .content-name-special {
    background: linear-gradient(to bottom, #fefdfa 28%, #fed58a 57%, #f7ca27 73%, #fdf2b5 92%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
    font-size: 30px;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
  }

  .content-name {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content-name__piece-name {
    font-size: 20px;
    font-weight: 500;
    color: white;
    text-align: center;
  }

  .content-name__prize-name {
    font-weight: 900;
    font-size: 2rem;
    letter-spacing: 1px;
    color: white;
    text-align: center;

    /* 3D extruded blue depth + outer glow */
    text-shadow:
      1px 1px 0 #2f7fe0,
      2px 2px 0 #2a72cf,
      3px 3px 0 #245fb8,
      4px 4px 0 #1f55a6,
      5px 5px 0 #1a4a93,
      6px 6px 0 #154080,
      7px 8px 6px rgba(0, 20, 60, 0.55);
  }

  .content-group {
    line-height: 1.25;
    padding-bottom: 24px;

    .content-header {
      font-weight: 600;
    }
  }
`;

const FooterContainer = styled.div`
  padding-bottom: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 4px;
  padding-inline: 12px;
  width: 100%;


   .footer-buttons{
    display: flex;
    gap: 20px;
  }

  .footer-button {
    background: linear-gradient(to right, #1ea317, #19b810);
    color: white;
    font-size: 14px;
    max-width: 180px;
    width: 100%;
    border-radius: 6px;
    border: none;
    padding: 10px 17px;
      font-weight: 600;
      word-break: break-word;
      white-space: normal;
      display: inline-block;
  }

  .footer-button-secondary{
    background: linear-gradient(to right, rgba(217, 96, 20, 1), rgba(254, 145, 4, 1));
  }

  .footer-sub-title {
    font-size: 14px;
    color: white;
    text-align: center;
    text-shadow:
      -1px -1px 0 #013f97,
      1px -1px 0 #013f97,
      -1px 1px 0 #013f97,
      1px 1px 0 #013f97;
    font-style: italic;
  }
`;

const Container = styled.div`
  position: relative;
  background-image: url(${bgCongrats});
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  // min-height: 680px;
  // aspect-ratio: 480 / 680;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .popup-coins {
    .container-bg {
      .bg-con-mini {
        height: 605px;
      }
    }
  }

  &.popup-no-coins {
    /* background-image: url(${bgNoCoins});
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    padding: 60px 0 40px; */

    .rule-mini-close {
      right: 5%;
      top: -20%;
      transform: translate(50%, -50%);
    }

    .bg-con-mini-wrapper {
      position: absolute;
      top: 0%;
      transform: translateY(-75%);

      .bg-con-mini {
        height: auto;
      }
    }

    .main-content-mini-piece {
      width: calc(100% - 60px);
      /* top: 195px; */
      top: 0 !important;
      position: relative;
    }

    .btn-container {
      button {
        padding: 10px 16px;
      }
    }

    .mission-icon {
      /* display: none; */
      display: grid;
      grid-template-columns: 50px calc(100% - 50px);
    }

    div .change-turn {
      margin-left: -52px;
    }

    .btn-cancel-change {
      margin-top: 10px;
    }

    .btn-confirm-change {
      margin-top: 15px;
    }

    .mini-icon-change {
      padding: 12px 0;
    }

    .coins-now-content {
      font-size: 24px;
      font-weight: 600;
      color: #101828;
      text-align: center;
    }

    .container-popup-mini-rule {
      margin-top: 10px;
      padding: 0 12px;
    }

    .container-icon-mission {
      width: 50px;
      height: 50px;

      img {
        width: 27px;
      }
    }

    .mission-name {
      font-size: 16px;
    }

    .mini-mission-footer {
      font-size: 14px;
    }

    .item-mission-container-mini {
      padding: 10px;
    }

    .flex-mission-icon {
      gap: 10px;
    }

    .change-turn {
      margin-left: -64px;
    }

    .warning-change-turn {
      font-size: 12px;
      padding: 10px 0;
    }

    @media (max-width: 450px) {
      div .btn-change-turn {
        font-size: 12px;
      }

      div .btn-total {
        /* font-size: 16px; */
      }
    }
  }

  .bg-con-mini {
    height: 668px;
  }

  .rule-mini-close {
    position: absolute;
    top: 10px;
    right: 0;
    z-index: 4;
  }

  .container-btn {
    margin: 10px 0;
    margin-bottom: 4px;
  }

  .footer-popup-mini-cong {
    text-align: center;
    color: #fff;
    margin-top: 10px !important;
  }

  .content-btn{
    position: unset;
    transform: unset;
    cursor: pointer;
    border: none;
    outline: none;
    width: calc(100% - 120px);
    max-width: 100%;
    padding: 10px 20px;
    font-size: 16px;
    color: #fff;
    margin: 0 auto;
    font-weight: 600;
    border-radius: 5px;
    background: linear-gradient(180deg, rgba(30, 163, 23, 1) 0%, rgba(25, 184, 16, 1) 100%);
}

  .name {
    text-shadow:
      -1px -1px 0 white,
      1px -1px 0 white,
      -1px 1px 0 white,
      1px 1px 0 white;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    color: #fff;

    background: linear-gradient(
        180deg,
        #fefdfa 0%,
        #fdf2b5 25%,
        #fed58a 60%,
        #f7ca27 100%
    );
   @media (min-width: 1200px) {
        line-height: 40px !important;
    }
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;

    /* Quan trọng */
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;    
  }

  .name-content {
    font-size: 24px;
    font-style: italic;
  }

  .name-title {
    font-size: 20px;
  }

  .icon {
    text-align: center;
    margin: 25px 0;
    margin-bottom: 20px;

    img {
      max-height: 245px;
      max-width: 100%;
    }
  }

  .main-content-mini-piece {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 75px;
    margin-bottom: 120px;
    z-index: 2;
    font-size: 16px;
    color: #64310b;
    font-weight: 500;
  }

  .main-content-mini-piece__free-bid {
    .main-content-mini-piece {
      top: 130px;
    }

    .bg-con-mini {
      height: 710px;
    }
  }

  .main-content-mini-piece__puzzle-piece {
    width: calc(100% - 100px);
    text-align: center;
    justify-content: center;
    top: 140px;

    .container-btn {
      text-align: center;
      display: flex;
      justify-content: center;
    }
  }

  .bg-super-con-mini {
    height: 680px;
    width: 496px;
  }

  .header {
    font-weight: 500;
    text-align: center;
  }

  .main-super-puzzle {
    /* width: max-content; */
    margin: 0 auto;
    .bg-con-mini {
      min-height: 556px;
      height: ${(props) => `${props.height}px`};
      max-width: 90vw;

      @media (max-width: 768px) {
        min-height: 350px;
      }
    }

    .container-btn {
      width: calc(100% - 30px);
      margin: 0 auto;
      max-width: 90%;
    }
  }

  .main-super-spin {
    .bg-super-con-mini {
      height: ${(props) => `${props.height}px`};
      min-height: 690px;
      max-width: 90vw;

      @media (max-width: 768px) {
        min-height: 640px;
      }
    }

    .main-content-mini-piece {
    }
  }

  @media (max-width: 768px) {
    .popup-coins {
      .container-bg {
        .bg-con-mini {
          height: 500px;
        }
      }
      .main-content-mini-piece {
        top: 75px;
        margin-bottom: 100px;
      }
    }

    .popup-free-bid {
      .main-content-mini-piece {
        top: 75px;
        margin-bottom: 100px;
      }

      .footer-popup-mini-cong,
      .header {
        padding: 0;
        font-size: 16px;
      }
    }

    .popup-no-coins {
      margin: 0 -25px;
      background-size: 80% 100%;

      .rule-mini-close {
        right: 15%;
      }

      .bg-con-mini-wrapper {
        .bg-con-mini {
          max-width: 80%;
        }
      }

      .main-content-mini-piece {
        width: calc(100% - 20px);
        top: 0;
      }

      /* .btn-container button {
        width: 30px;
        height: 30px;
      } */

      /* .btn-total {
        height: 30px;
      } */

      .btn-change-turn {
        font-size: 14px;
      }

      .container-change-coins-mini .btn-change-turn {
        width: max-content;
      }

      .mini-change-coins-header {
        font-size: 13px;
      }

      .total-mini-change {
        font-size: 18px;
      }

      .bg-con-mini {
        height: 630px;
      }

      .header {
        font-size: 16px;
      }

      .coins-now-content {
        font-size: 20px;
      }

      .mission-name {
        font-size: 14px;
        line-height: 21px;
      }

      .mini-mission-footer {
        font-size: 12px;
      }

      .container-popup-mini-rule {
        padding: 0;
      }
    }

    .main-content-mini-piece {
      top: 150px;
      width: calc(100% - 55px);
    }

    .bg-con-mini {
      height: 525px;
    }

    .main-content-mini-piece__free-bid {
      .main-content-mini-piece {
        top: 115px;
      }

      .bg-con-mini {
        height: 610px;
      }
    }

    .main-content-mini-piece {
      max-width: 82%;
    }

    /* .main-content-mini-piece__puzzle-piece {
      margin-top: -20px;
    } */

    .bg-super-con-mini {
      height: 640px;
      display: flex;
      justify-content: center;
      margin: 0 auto;
      text-align: center;
    }

    .icon {
      margin: 15px 0;
      margin-bottom: 5px;

      img {
        max-height: 150px;
      }
    }

    .button-action-popup-mini {
      min-height: 45px;
      width: 100% !important;
      text-align: center;

      /* img {
        height: 45px;
        width: 260px;
      } */
    }

    .footer-popup-mini-cong,
    .header {
      padding: 0 10px;
    }
  }

  @media (max-width: 576px) {
    .popup-free-bid.popup-puzzle-piece .name {
      font-size: 28px;
      line-height: 25px;
    }

    .main-content-mini-piece.main-content-mini-piece-super-coin {
      /* top: 120px; */

      /* .icon img {
        max-height: 140px !important;
      }

      .name {
        font-size: 26px;
        line-height: 33px;
        padding: 5px 0;
      }

      .footer-popup-mini-cong {
        font-size: 13px;
      }

      .header {
        line-height: 22px;
      } */
    }
  }

  @media (max-width: 492px) {
    .popup-no-coins {
      max-width: 90dvw;
      margin: 0 auto;
      background-size: 100% 100%;
      padding-top: 50px;

      .rule-mini-close {
        right: 10%;
      }

      .bg-con-mini-wrapper {
        .bg-con-mini {
          max-width: 90%;
        }
      }

      .main-content-mini-piece {
      }
    }
  }

  @media (max-width: 452px) {
    .button-action-popup-mini {
      min-height: 45px;
      width: 100% !important;
      text-align: center;

      img {
        /* height: 45px; */
        width: 300px;
      }
    }

    .name {
      font-size: 26px;
      line-height: 33px;
      padding: 5px 0;
    }

    .footer-popup-mini-cong {
      font-size: 13px;
    }

    .header {
      line-height: 22px;
    }
  }

  @media (max-width: 440px) {
    .popup-no-coins {
      max-width: 95dvw;
      margin: 0 auto;
      background-size: 100% 100%;
      padding-top: 40px;

      .bg-con-mini-wrapper {
        .bg-con-mini {
          max-width: 100%;
        }
      }

      .main-content-mini-piece {
        padding: 0 10px;
      }
    }

    .name {
      font-size: 22px;
      line-height: 33px;
      padding: 0 0;
    }

    .header {
      line-height: 23px;
    }
  }

  @media (max-width: 412px) {
    .main-content-mini-piece.main-content-mini-piece-super-coin {
      top: 135px;
    }
    .button-action-popup-mini {
      img {
        height: 50px;
        width: 260px;
      }
    }
  }

  @media (max-width: 392px) {
    .popup-no-coins {
      .header {
        font-size: 14px;
      }

      .coins-now-content {
        font-size: 16px;
      }

      .warning-change-turn {
        margin-top: 5px;
        padding: 10px 10px;
        font-size: 11px;
      }
    }
  }

  .popup-puzzle-piece {
    .icon img {
      min-height: 120px;
    }

    .main-content-mini-piece {
      .header {
        font-size: 18px;
            background: unset !important;
            border: unset;
            height: max-content;
            margin-bottom: 10px;
      }
    }

    .name {
      font-family: "Ganache", sans-serif;
      font-size: 36px;
      text-shadow: unset;
    }
  }

  @media (max-width: 576px) {
    .popup-puzzle-piece {
    }
  }

  @media (max-width: 386px) {
    .popup-no-coins {
      .main-content-mini-piece {
        width: calc(100% - 20px);
        top: 175px;
      }
      .warning-change-turn {
        padding: 10px 0;
      }
    }
  }

  @media (max-width: 368px) {
    .popup-no-coins {
      .header {
        font-size: 12px;
      }

      .coins-now-content {
        font-size: 14px;
      }

      .warning-change-turn {
        padding: 10px 24px;
      }
    }
  }

  .puzzle-piece-minigame {
    .main-content-mini-piece {
      position: relative;
      /* top: 65px !important; */
      /* max-width: calc(100% - 60px); */
      max-width: 100%;
      padding: 0 30px;
      width: auto;
      /* left: 50%;
      transform: translateX(-50%) */
    }

    .bg-super-con-mini,
    .bg-con-mini {
      position: absolute;
      height: 680px;
      min-height: auto;
      max-height: 680px;
      width: calc(100%);
      /* top: -65px; */
      left: 50%;
      transform: translateX(-50%);
    }

    .button-action-popup-mini {
      text-align: center;
      width: 100%;
    }

    .main-super-puzzle {
      width: auto !important;
    }

    .rule-mini-close {
      top: -46px;
    }
  }
`;
